// extracted by mini-css-extract-plugin
export default {"ImageCaption":"ImageCaption_ImageCaption__ZWYwZ","Title":"ImageCaption_Title__YjM1N","Credit":"ImageCaption_Credit__M2ZiY","Icon":"ImageCaption_Icon__YWY1N"};